import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(providers)/SWRProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
